const exercicesReducer = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_EXERCICES':
      return action.data
    default:
      return state
  }
}

export default exercicesReducer
